import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const links = [
    { href: '#accueil', label: 'Accueil' },
    { href: '#presentation', label: 'La Remorque' },
    { href: '#pourquoi', label: 'Pourquoi nous choisir' },
    { href: '#tarifs', label: 'Tarifs' },
    { href: '#personnalisation', label: 'Personnalisation' },
    { href: '#devis', label: 'Devis' },
    { href: '#services', label: 'Nos Clients' },
    { href: '#apropos', label: 'À Propos' },
    { href: '#contact', label: 'Contact' },
  ];

  return (
    <header
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/85 backdrop-blur-md shadow-sm border-b border-gray-100/40'
          : 'bg-white/30 backdrop-blur-md'
      }`}
    >
      <nav className="mx-auto px-4 sm:px-5 lg:px-12 xl:px-20 2xl:px-24 w-full max-w-[1920px]">
        <div className="flex items-center justify-between h-20 lg:h-24">
          <a href="#accueil" className="cursor-pointer -ml-1">
            <img
              src="https://storage.readdy-site.link/project_files/d8db5950-dd7c-40d9-b2de-72ddcdf21388/51e73aae-ba15-478d-bf7b-7a4446e0d24c_fond-transparent.png?v=f8b7e998649839c3a23fd4205efaa02e"
              alt="PLUG and BAR LM Logo"
              className="h-14 lg:h-[72px] w-auto max-w-[240px] lg:max-w-[320px]"
            />
          </a>
          <div className="hidden lg:flex flex-1 items-center justify-end gap-x-3 xl:gap-x-4">{links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="font-bold text-gray-900 text-xs lg:text-sm tracking-wide transition-colors duration-300 cursor-pointer hover:text-[#00A8B5] whitespace-nowrap"
              >
                {l.label}
              </a>
            ))}
          </div>
          <button
            className="lg:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-gray-700 text-lg`}></i>
          </button>
        </div>
      </nav>
      {mobileOpen && (
        <div className="lg:hidden bg-white/95 backdrop-blur-md shadow-lg border-t border-gray-200/30">
          <div className="px-4 py-4 space-y-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="block text-gray-700 hover:text-[#00A8B5] transition-colors cursor-pointer"
                onClick={() => setMobileOpen(false)}
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}